import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { InterpretationService } from '../../interpretation.service';
import { NotificationsService } from 'angular2-notifications';
import { MatDialog } from '@angular/material/dialog';import { UserService } from '../../../../shared/services/user.service';
import { InspectionAdditionalObservationListsViewModel, PopupEndPoint } from '../../../inspection/models/create-inspection.model';
import { ComponentCommentModalComponent } from '../component-comment-modal/component-comment-modal.component';





@Component({
  selector: 'add-component-comment',
  templateUrl: './add-component-comment.component.html',
  styleUrls: ['./add-component-comment.component.scss']
})


export class AddComponentCommentComponent implements OnInit {
  @Input() inspectionId: number;
  @Input() inspectionDetailId: number;
  @Output() onCommentChange: EventEmitter<any> = new EventEmitter();
  @Input() comment = '';
  @Input()  endPoint: PopupEndPoint;
  @Input() observationList: InspectionAdditionalObservationListsViewModel;
  @Output() updateComment:EventEmitter<any> = new EventEmitter();
    @Output() SystemPhotoUpload:EventEmitter<any> = new EventEmitter();
  @Input() CompartTypeId: number;
  @Input() ScreenId: number;
  @Input() SystemId: number;
  isInspector = false;
  isInterpreter = false;

  constructor(
    private _interp: InterpretationService,
    private _notify: NotificationsService,
    private _dialog: MatDialog,
    private _user: UserService,) { }

  ngOnInit() {
    
    this.checkPermissions();

   
  }

 

  checkPermissions() {
    this._user.getUserJobRoles().subscribe(
      jobRoles => {
        jobRoles.forEach(role => {
          switch (role.Name) {
            case 'Inspectors':
              this.isInspector = true;
              break;
            case 'Interpreters':
            case 'Super User':
            case 'Administrator':
              this.isInterpreter = true;
              this.isInspector = true;
              break;
              case 'Customer Admin':
                this.isInspector = true;
              this.isInterpreter = true;
                break;
                case 'Undercarriage ONLY':
                case 'Undercarriage Inspector ONLY':
                 this.isInspector = true;
                break;
          }
        });
      },
      error => {
        console.error(error);
        this._notify.error('Error', 'Unable to check your job roles. ');
      }
    );
  }

  viewComponentComment() {
    let passingData;
    if (this.endPoint) {
      switch (this.endPoint) {
        case PopupEndPoint.ObservationListInterpretation:
          passingData = {
            inspectionId: this.inspectionId,
            comment: this.comment,
            comingFrom: this.endPoint,
            observationList: this.observationList,
            showplus:false,
          };
        break;
      }
    } else {
      passingData = {
        inspectionId: this.inspectionId,
        inspectionDetailId: this.inspectionDetailId,
        comment: this.comment,
        showplus:true,
        CompartTypeId:this.CompartTypeId,
        ScreenId : this.ScreenId,
        SystemId: this.SystemId,
        
      };
    }
    const viewCommentModalRef = this._dialog.open(ComponentCommentModalComponent, {
      width: '1032px',
      data: passingData,
    });
    viewCommentModalRef.afterClosed().subscribe(reloadComment => {
      if (reloadComment){
        if(this.SystemId>0){
         this.SystemPhotoUpload.emit({ SystemId: this.SystemId});
        }
        this.updateComment.emit(reloadComment);
        this.onCommentChange.emit();
      }
    });
  }
}
